module.exports = __webpack_public_path__ + "static/Pump-Station-pg1-c02983b7b9b2062065c971d2dd9e52f0.jpg";